import { BlockIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { CustomDomainContextMenu } from './CustomDomainContextMenu';
import { DomainItemContainer, DomainItemStatusBadge, DomainItemValue } from './DomainItem';
import { DomainItemProps } from './PendingDomainItem';
import { ProvisioningStep } from './ProvisioningSteps';
import { ProvisioningStepsTooltip } from './ProvisioningStepsTooltip';

export const InactiveDomainItem = ({
  label,
  actions,
  value,
  status,
  step,
  steps,
}: DomainItemProps & { status: string; step?: string; steps?: ProvisioningStep[] }) => {
  const translate = useTranslate();
  const badge = (
    <DomainItemStatusBadge
      className='bg-red-pomegranate text-white'
      icon={<BlockIcon color='white' />}
      label={translate(`labels.${status}`)}
    />
  );

  return (
    <DomainItemContainer>
      {step && status && steps ? (
        <ProvisioningStepsTooltip currentStepVal={step} status={status} steps={steps}>
          {badge}
        </ProvisioningStepsTooltip>
      ) : (
        badge
      )}

      <DomainItemValue label={label} value={value} />
      <div className='ml-auto'>
        <CustomDomainContextMenu actions={actions} />
      </div>
    </DomainItemContainer>
  );
};
